<button
    type="button"
    class="btn"
    [ngClass]="{'primary-color': color === 'primary', 'secondary-color': color === 'secondary', 'blue-color': color === 'blue', 'disabled': isDisabled }">
  <ng-content></ng-content>
  <span *ngIf="title" class="title" [ngClass]="{'primary-title': color === 'primary'}">{{ title }}</span>
</button>
